<div class="flex flex-column gap-4">
    <p-accordion [multiple]="true" [activeIndex]="[0]" expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
        <p-accordionTab header="Course Management">

            <div
                class="flex flex-column md:flex-row justify-content-between align-items-start md:align-items-center gap-3 mb-4">
                <div>
                    <p class="text-500 m-0 font-medium">Manage courses offered by this institute</p>
                    <p class="text-600 m-0 text-sm mt-1 flex align-items-center">
                        <i class="pi pi-info-circle mr-2"></i>
                        {{ courses.length }} courses added
                    </p>
                </div>
                <button pButton label="Add Course" icon="pi pi-plus" class="custom-btn-primary"
                    (click)="openAddCourseDialog()"></button>
            </div>

            <div *ngIf="courses.length === 0"
                class="flex flex-column align-items-center justify-content-center p-6 border-dashed border-1 border-300 border-round surface-0">
                <i class="pi pi-graduation-cap text-5xl text-400 mb-3"></i>
                <div class="text-xl font-medium text-900 mb-2">No courses added yet</div>
                <div class="text-500 mb-4">Start by adding your first course</div>
                <button pButton label="Add First Course" icon="pi pi-plus" class="btn-add-first-course"
                    (click)="openAddCourseDialog()"></button>
            </div>

            <div *ngIf="showCoursesError && courses.length === 0" class="flex justify-content-center mt-3">
                <small class="p-error font-medium text-lg">
                    <i class="pi pi-exclamation-circle mr-2"></i>
                    At least one course is required to finish.
                </small>
            </div>

            <div *ngIf="courses.length > 0" class="courses-table-section">
                <p-table
                    [value]="courses.controls"
                    styleClass="p-datatable-gridlines tableCon"
                    [tableStyle]="{ 'min-width': '50rem' }">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Course Name</th>
                            <th>Level</th>
                            <th>Duration</th>
                            <th>Study Mode</th>
                            <th>Fees</th>
                            <th>Actions</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-course let-i="rowIndex">
                        <tr>
                            <td>{{ course.value.name || 'Unnamed Course' }}</td>
                            <td>
                                <span class="level-badge"
                                    [class.doctoral]="course.value.level === 'Doctoral Degree'"
                                    [class.masters]="course.value.level === 'Master\'s Degree'"
                                    [class.bachelors]="course.value.level === 'Bachelor\'s Degree'"
                                    [class.diploma]="course.value.level === 'Diploma'"
                                    [class.certificate]="course.value.level === 'Certificate'">
                                    {{ course.value.level || 'N/A' }}
                                </span>
                            </td>
                            <td>{{ course.value.duration ? course.value.duration + ' yrs' : 'N/A' }}</td>
                            <td>{{ course.value.studyMode || 'N/A' }}</td>
                            <td>{{ course.value.fees ? currencySymbol(course.value.currency) + course.value.fees : 'N/A' }}</td>
                            <td>
                                <div class="w-auto inline-flex justify-content-center gap-1">
                                    <button pButton icon="pi pi-pencil"
                                        class="p-button-rounded p-button-text p-button-sm"
                                        pTooltip="Edit" tooltipPosition="top"
                                        (click)="editCourse(i)"></button>
                                    <button pButton icon="pi pi-trash"
                                        class="p-button-rounded p-button-text p-button-sm p-button-danger"
                                        pTooltip="Delete" tooltipPosition="top"
                                        (click)="removeCourse(i)"></button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

        </p-accordionTab>
    </p-accordion>
</div>

<p-dialog
    [header]="editingIndex !== null ? 'Edit Course' : 'Add New Course'"
    [(visible)]="showAddCourseDialog"
    [modal]="true"
    [style]="{width: '50vw'}"
    [breakpoints]="{'960px': '75vw', '640px': '90vw'}"
    [draggable]="false"
    [resizable]="false">

    <div class="flex flex-column gap-3 pt-3" [formGroup]="courseForm">

        <div class="formgrid grid">
            <div class="field col-12 md:col-6">
                <label class="font-medium text-900">Course Level</label>
                <p-dropdown
                    [options]="levels"
                    placeholder="Select level"
                    styleClass="w-full"
                    [showClear]="true"
                    formControlName="level"
                    [ngClass]="{'ng-invalid ng-dirty': courseForm.get('level')?.invalid && courseForm.get('level')?.touched}">
                </p-dropdown>
                <small *ngIf="courseForm.get('level')?.invalid && courseForm.get('level')?.touched"
                    class="p-error block mt-1">Course level is required.</small>
            </div>

            <div class="field col-12 md:col-6">
                <label class="font-medium text-900">Course Name</label>
                <input pInputText type="text" class="w-full"
                    placeholder="e.g., Bachelor of Computer Science"
                    formControlName="name"
                    [ngClass]="{'ng-invalid ng-dirty': courseForm.get('name')?.invalid && courseForm.get('name')?.touched}" />
                <div *ngIf="courseForm.get('name')?.touched && courseForm.get('name')?.invalid">
                    <small *ngIf="courseForm.get('name')?.hasError('required')" class="p-error block mt-1">
                        Course name is required.
                    </small>
                    <small *ngIf="courseForm.get('name')?.hasError('pattern')" class="p-error block mt-1">
                        Must contain only letters and spaces.
                    </small>
                </div>
                <small *ngIf="courseForm.get('name')?.hasError('courseNameExists')" class="p-error block mt-1">
                    A course with this name already exists.
                </small>
            </div>

            <div class="field col-12">
                <label class="font-medium text-900 mb-2 block">Different Course Names</label>
                <div class="flex flex-wrap gap-2 mb-2">
                    <div *ngFor="let nameCtrl of courseNames.controls; let i = index" class="campus-chip">
                        <span>{{ nameCtrl.value }}</span>
                        <i class="pi pi-times chip-close" (click)="removeCourseName(i)"></i>
                    </div>
                </div>
                <div class="flex gap-2">
                    <input pInputText type="text" #newName class="w-full campus-input"
                        placeholder="Add another course name"
                        (keyup.enter)="addCourseName(newName.value); newName.value = ''" />
                    <button pButton label="Add" type="button" class="campus-add-btn"
                        (click)="addCourseName(newName.value); newName.value = ''"></button>
                </div>
                <div *ngIf="courseForm.get('courseNames')?.touched && courseForm.get('courseNames')?.invalid">
                    <small class="p-error block mt-1">
                        Some course names have invalid characters (must contain only letters and spaces).
                    </small>
                </div>
            </div>

            <div class="field col-12 md:col-6">
                <label class="font-medium text-900">Major/Stream</label>
                <input pInputText type="text" class="w-full"
                    placeholder="e.g., Artificial Intelligence, Data Science" formControlName="major" />
                <small class="text-500 block mt-1">Separate multiple majors with commas.</small>
                <div *ngIf="courseForm.get('major')?.touched && courseForm.get('major')?.invalid">
                    <small *ngIf="courseForm.get('major')?.hasError('required')" class="p-error block mt-1">Major or
                        stream is required.</small>
                    <small *ngIf="courseForm.get('major')?.hasError('pattern')" class="p-error block mt-1">Only letters,
                        numbers, spaces and commas are allowed.</small>
                </div>
            </div>

            <div class="field col-12 md:col-6">
                <label class="font-medium text-900">Course Short Form</label>
                <input pInputText type="text" class="w-full"
                    placeholder="e.g., B.Sc CS"
                    formControlName="shortForm" />
                <div *ngIf="courseForm.get('shortForm')?.touched && courseForm.get('shortForm')?.invalid">
                    <small *ngIf="courseForm.get('shortForm')?.hasError('pattern')" class="p-error block mt-1">
                        Must be alphanumeric.
                    </small>
                </div>
            </div>

            <div class="field col-12 md:col-6">
                <label class="font-medium text-900">CIP Code</label>
                <input pInputText type="text" class="w-full"
                    placeholder="e.g., 110701"
                    formControlName="cipCode" />
                <div *ngIf="courseForm.get('cipCode')?.touched && courseForm.get('cipCode')?.invalid">
                    <small *ngIf="courseForm.get('cipCode')?.hasError('pattern')" class="p-error block mt-1">
                        Must be a number.
                    </small>
                </div>
            </div>

            <div class="field col-12 md:col-6">
                <label class="font-medium text-900">Study Mode</label>
                <p-dropdown
                    [options]="studyModes"
                    placeholder="Select mode"
                    styleClass="w-full"
                    [showClear]="true"
                    formControlName="studyMode">
                </p-dropdown>
                <div *ngIf="courseForm.get('studyMode')?.touched && courseForm.get('studyMode')?.invalid">
                    <small *ngIf="courseForm.get('studyMode')?.hasError('required')" class="p-error block mt-1">
                        Study mode is required.
                    </small>
                </div>
            </div>

            <div class="field col-12 md:col-6">
                <label class="font-medium text-900">Duration (Years)</label>
                <input pInputText type="text" class="w-full" placeholder="e.g., 4 or 1.5" formControlName="duration" />
                <div *ngIf="courseForm.get('duration')?.touched && courseForm.get('duration')?.invalid">
                    <small *ngIf="courseForm.get('duration')?.hasError('required')" class="p-error block mt-1">Duration
                        is required.</small>
                    <small *ngIf="courseForm.get('duration')?.hasError('pattern')" class="p-error block mt-1">Enter a
                        number of years (e.g., 4 or 1.5).</small>
                </div>
            </div>

            <div class="field col-12 md:col-6">
                <label class="font-medium text-900">Start Date</label>
                <p-calendar
                    placeholder="dd-mm-yyyy"
                    styleClass="w-full"
                    [showIcon]="true"
                    appendTo="body"
                    formControlName="startDate">
                </p-calendar>
                <div *ngIf="courseForm.get('startDate')?.touched && courseForm.get('startDate')?.invalid">
                    <small *ngIf="courseForm.get('startDate')?.hasError('required')" class="p-error block mt-1">
                        Start Date is required.
                    </small>
                </div>
            </div>

            <div class="field col-12 md:col-6">
                <label class="font-medium text-900">Course Location</label>
                <input pInputText type="text" class="w-full"
                    placeholder="e.g., Main Campus, Building A"
                    formControlName="location" />
                <div *ngIf="courseForm.get('location')?.touched && courseForm.get('location')?.invalid">
                    <small *ngIf="courseForm.get('location')?.hasError('required')" class="p-error block mt-1">
                        Course Location is required.
                    </small>
                </div>
            </div>

            <div class="field col-12 md:col-6">
                <label class="font-medium text-900">Course URL</label>
                <input pInputText type="text" class="w-full"
                    placeholder="https://..."
                    formControlName="url" />
                <div *ngIf="courseForm.get('url')?.touched && courseForm.get('url')?.invalid">
                    <small *ngIf="courseForm.get('url')?.hasError('required')" class="p-error block mt-1">
                        Course URL is required.
                    </small>
                    <small *ngIf="courseForm.get('url')?.hasError('pattern')" class="p-error block mt-1">
                        Please enter a valid URL (e.g. https://example.com).
                    </small>
                </div>
            </div>
        </div>

        <div>
            <div class="border-top-1 border-300 mb-4"></div>
            <h5 class="font-bold text-900 m-0 mb-3">Financial Information</h5>
            <div class="formgrid grid">
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">Currency</label>
                    <p-dropdown [options]="currencies" placeholder="Select currency" styleClass="w-full"
                        [showClear]="true" formControlName="currency"></p-dropdown>
                    <div *ngIf="courseForm.get('currency')?.touched && courseForm.get('currency')?.invalid">
                        <small *ngIf="courseForm.get('currency')?.hasError('required')" class="p-error block mt-1">Currency
                            is required.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label class="font-medium text-900">Course Fees</label>
                    <input pInputText type="text" class="w-full" placeholder="e.g., 50000" formControlName="fees" />
                    <div *ngIf="courseForm.get('fees')?.touched && courseForm.get('fees')?.invalid">
                        <small *ngIf="courseForm.get('fees')?.hasError('required')" class="p-error block mt-1">Course
                            Fees is required.</small>
                        <small *ngIf="courseForm.get('fees')?.hasError('pattern')" class="p-error block mt-1">Enter a
                            numeric amount only.</small>
                    </div>
                </div>
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">One-Time Payment</label>
                    <input pInputText type="text" class="w-full"
                        placeholder="e.g., $5,000"
                        formControlName="oneTimePayment" />
                </div>
                <div class="field col-6 md:col-6">
                    <label class="font-medium text-900">Living Expenses</label>
                    <input pInputText type="text" class="w-full"
                        placeholder="e.g., $15,000/year"
                        formControlName="livingExpenses" />
                </div>
            </div>
        </div>

        <div>
            <div class="border-top-1 border-300 mb-4"></div>
            <h5 class="font-bold text-900 m-0 mb-3">Career Outcomes</h5>
            <div class="formgrid grid">
                <div class="field col-12 md:col-6">
                    <label class="font-medium text-900">Median Earnings Post-Graduation</label>
                    <input pInputText type="text" class="w-full"
                        placeholder="e.g., $65,000"
                        formControlName="medianEarnings" />
                </div>
                <div class="field col-12 md:col-4">
                    <label class="font-medium text-900">Earnings After 5 Years</label>
                    <input pInputText type="text" class="w-full"
                        placeholder="e.g., $95,000"
                        formControlName="earnings5Years" />
                </div>
            </div>
        </div>

        <div>
            <h5 class="font-bold text-900 m-0 mb-3">Additional Details</h5>
            <div class="formgrid grid">
                <div class="field col-12 md:col-6 flex align-items-center gap-3">
                    <p-checkbox
                        formControlName="studentExchangePrograms"
                        [binary]="true"
                        inputId="studentExchangePrograms">
                    </p-checkbox>
                    <label for="studentExchangePrograms" class="font-medium text-900 mb-0 cursor-pointer">
                        Student Exchange Programs
                    </label>
                </div>
            </div>
        </div>

        <div>
            <h5 class="font-bold text-900 m-0 mb-3">
                Eligibility Requirements
            </h5>
            <div class="field col-12 p-0">
                <textarea pInputTextarea rows="4" class="w-full"
                    placeholder="Enter eligibility criteria..."
                    formControlName="eligibility">
                </textarea>
                <div *ngIf="courseForm.get('eligibility')?.touched && courseForm.get('eligibility')?.invalid">
                    <small *ngIf="courseForm.get('eligibility')?.hasError('required')" class="p-error block mt-1">
                        Eligibility Requirement is required.
                    </small>
                </div>
            </div>
        </div>

        <div>
            <h5 class="font-bold text-900 m-0 mb-3">
                English Language Requirement
            </h5>
            <div class="field col-12 p-0">
                <textarea pInputTextarea rows="4" class="w-full"
                    placeholder="Enter English language requirements (e.g. IELTS 6.5, TOEFL 90)..."
                    formControlName="englishLanguageRequirement">
                </textarea>
            </div>
        </div>

    </div>

    <ng-template pTemplate="footer">
        <button pButton label="Cancel" class="p-button-outlined p-button-secondary"
            (click)="closeAddCourseDialog()"></button>
        <button pButton
            [label]="editingIndex !== null ? 'Update Course' : 'Add Course'"
            class="custom-btn-primary"
            [loading]="savingCourse"
            (click)="addCourse()">
        </button>
    </ng-template>
</p-dialog>

<p-confirmDialog></p-confirmDialog>
